<!-- 组件 -->
<template>
    <div class="sideBar">
        <div class="logo"><img src="@/assets/logo.png"></div>
        <div class="device-title">土壤多参数自动监测站</div>
        <div class="xrow ai-c jc-c">
            <a @click="back" class="return-button">
                返回设备
            </a>
        </div>
        <div class="menu mgt20">
            <ul>
                <li v-for="(silder,index) in silders" :key="index">
                    <!-- <router-link :to="silder.to" class="menu-item"><i :class="silder.icon"></i><span>{{silder.name}}</span></router-link> -->
                    <div :class="[activeName===silder.to.params.type?'active':'','menu-item']" style="cursor:pointer" @click="changeDetail(silder)">
                        <i :class="silder.icon"></i><span>{{silder.name}}</span>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
/**
 * 传感器左侧
 */
 import {soilDetailList} from "@/utils/config.js"
import { parseMLine } from "ezuikit-js";
 import {forEach} from "lodash"
export default {
    name: 'sensorsidebar',
    props: {},
    data() {
        return {
            EncoderId: '',
            Encoder: {},
            checkoutDialog: false,
            silders: soilDetailList,
            activeName:""
        }
    },
    mounted() {
        this.EncoderId = this.$route.params.id
        const Group = this.$route.params.group;
        this.getActiveItem(Group)
      //  console.log("this.EncoderId=",EncoderId,"-- this.Group--", Group)
     //   this.loadData()
    },
    created() {
        this.EncoderId = this.$route.params.id
    },
    methods: {
        getActiveItem(param){
            forEach(soilDetailList,item=>{
                if(param.indexOf(item.to.params.type) !==-1){
                   this.activeName=item.to.params.type;
                }
            })
        },
        loadData() {
            // 加载设备的数据
            this.$request('encoder', 'info', {
                encoderId: this.EncoderId
            }).then(res => {
                if (res.code === 1) {
                    this.Encoder = res.data
                    this.silders = [
                        {
                            to: {
                                name: 'soilsensor',
                                params: {
                                    id: this.EncoderId,
                                    group: 'temperature'
                                }
                            },
                            icon: 's-125',
                            name: '土壤温度',
                            sid: 125
                        },
                        {
                            to: {
                                name: 'soilsensor',
                                params: {
                                    id: this.EncoderId,
                                    group: 'humidity'
                                }
                            },
                            icon: 's-126',
                            name: '土壤湿度',
                            sid: 126
                        },
                        {
                            to: {
                                name: 'soilsensor',
                                params: {
                                    id: this.EncoderId,
                                    group: 'salinity'
                                }
                            },
                            icon: 's-128',
                            name: '土壤盐分',
                            sid: 128
                        },
                        {
                            to: {
                                name: 'soilsensor',
                                params: { id: this.EncoderId, group: 'pH' }
                            },
                            icon: 's-127',
                            name: '土壤pH',
                            sid: 127
                        },
                        {
                            to: {
                                name: 'soilsensor',
                                params: {
                                    id: this.EncoderId,
                                    group: 'conductivity'
                                }
                            },
                            icon: 's-129',
                            name: '土壤电导率',
                            sid: 129
                        }
                    ]
                }
            })
        },
        back() {
            this.$router.push({
                name: 'soil',
                params: { id: this.EncoderId }
            })
        },
        changeDetail(param){
            this.activeName=param.to.params.type;
            this.$router.push({
                            path: `/encoder/soil/sensor/${param.to.params.type}/${this.EncoderId}`,
                           // query: { id:marker.key },
                  });
        }
    }
}
</script>
<style lang='less' scoped>

.sideBar {
    position: fixed;
    top: 0px;
    left: 0px;
    bottom: 0px;
    overflow: hidden;
    background: #fff;

    z-index: 1000;
    width: 175px;
    border-right: 1px solid #f0f3f7;

    .logo {
        text-align: center;
        padding-top: 45px;

        img {
            width: 110px;
            height: 110px;
        }
    }

    .menu {
        .menu-item {
            user-select: none;
            display: block;
            background-color: #fff;
            border-left: solid 6px #fff;
            height: 45px;
            line-height: 45px;
            padding-left: 15px;
            text-align: left;

            span {
                color: #1f2b4f;
                font-size: 14px;
                margin-left: 12px;
                display: inline-block;
                vertical-align: middle;
            }

            i {
                display: inline-block;
                width: 16px;
                height: 16px;
                vertical-align: middle;

                &.s-105 {
                    background: url(../../../assets/moff/105.png) no-repeat;
                }

                &.s-106 {
                    background: url(../../../assets/moff/106.png) no-repeat;
                }

                &.s-107 {
                    background: url(../../../assets/moff/107.png) no-repeat;
                }

                &.s-108 {
                    background: url(../../../assets/moff/108.png) no-repeat;
                }

                &.s-109 {
                    background: url(../../../assets/moff/109.png) no-repeat;
                }

                &.s-113 {
                    background: url(../../../assets/moff/113.png) no-repeat;
                }

                &.s-119 {
                    background: url(../../../assets/moff/119.png) no-repeat;
                }

                &.s-120 {
                    background: url(../../../assets/moff/120.png) no-repeat;
                }

                &.s-121 {
                    background: url(../../../assets/moff/121.png) no-repeat;
                }

                &.s-123 {
                    background: url(../../../assets/moff/123.png) no-repeat;
                }

                &.s-125 {
                    background: url(../../../assets/moff/125.png) no-repeat;
                }

                &.s-126 {
                    background: url(../../../assets/moff/126.png) no-repeat;
                }

                &.s-127 {
                    background: url(../../../assets/moff/127.png) no-repeat;
                }

                &.s-128 {
                    background: url(../../../assets/moff/128.png) no-repeat;
                }

                &.s-129 {
                    background: url(../../../assets/moff/129.png) no-repeat;
                }

                &.s-147 {
                    background: url(../../../assets/moff/147.png) no-repeat;
                }

                &.s-148 {
                    background: url(../../../assets/moff/148.png) no-repeat;
                }
            }

            &.active,
            &:hover {
                background-color: #e1faf1;
                border-left: solid 6px #3fcdae;

                span {
                    color: #3fcdae;
                    font-weight: bold;
                }

                .s-105 {
                    background: url(../../../assets/mon/105.png) no-repeat;
                }

                .s-106 {
                    background: url(../../../assets/mon/106.png) no-repeat;
                }

                .s-107 {
                    background: url(../../../assets/mon/107.png) no-repeat;
                }

                .s-108 {
                    background: url(../../../assets/mon/108.png) no-repeat;
                }

                .s-109 {
                    background: url(../../../assets/mon/109.png) no-repeat;
                }

                .s-113 {
                    background: url(../../../assets/mon/113.png) no-repeat;
                }

                .s-119 {
                    background: url(../../../assets/mon/119.png) no-repeat;
                }

                .s-120 {
                    background: url(../../../assets/mon/120.png) no-repeat;
                }

                .s-121 {
                    background: url(../../../assets/mon/121.png) no-repeat;
                }

                .s-123 {
                    background: url(../../../assets/mon/123.png) no-repeat;
                }

                .s-125 {
                    background: url(../../../assets/mon/125.png) no-repeat;
                }

                .s-126 {
                    background: url(../../../assets/mon/126.png) no-repeat;
                }

                .s-127 {
                    background: url(../../../assets/mon/127.png) no-repeat;
                }

                .s-128 {
                    background: url(../../../assets/mon/128.png) no-repeat;
                }

                .s-129 {
                    background: url(../../../assets/mon/129.png) no-repeat;
                }

                .s-147 {
                    background: url(../../../assets/mon/147.png) no-repeat;
                }

                .s-148 {
                    background: url(../../../assets/mon/148.png) no-repeat;
                }
            }
        }
    }

    .device-title {
        display: block;
        padding-top: 14px;
        color: #000;
        font-size: 16px;
        font-weight: bold;
        text-align: center;
    }

    .return-button {
        display: inline-block;
        width: 86px;
        height: 28px;
        border-radius: 25px;
        border: solid 1px #9de6d6;
        line-height: 28px;
        color: #3fcdae;
        font-size: 13px;
        margin-top: 10px;
        text-align: center;
        cursor: pointer;

        &:hover {
            font-weight: bold;
        }
    }
}
</style>
